import React, {useEffect} from "react";
import { PiMicrophoneStage } from "react-icons/pi";
import { GrCirclePlay } from "react-icons/gr";
import { IoTimeOutline } from "react-icons/io5";
import { useNavigate, useParams } from "react-router";
import SongCard from "../reusable/SongCard";

// music context
import { useMusic } from "../../context/MusicContext";

const MusicSeeall = ({ data }) => {
  const musicContext = useMusic();
  const {category_type} = useParams();
  const navigate = useNavigate();

  // musicContext.setCurrentIndex(null);
  const handleDetail = (id) => {
    navigate(`/music/detail/${category_type}/${id}`);
  }

  useEffect(() => {
    console.log(data);
    if(data) {
      let copyData = data.filter((music) => music.can_play == 1);
      musicContext.setDummyPlayList(copyData);
    }
  }, [data]);


  return (
    <>
      {data.map((item) => (
       <SongCard key={item.id} item={item} />
      ))}
    </>
  );
};

export default MusicSeeall;
